const VERIFIY_NUMBERS_BACKEND = "/settings/verify-numbers";

module.exports = {
    atLeastOneOptionSelected: function (options) {
        if (options.filter(option => option.selected).length) {
            return true;
        }

        return 'You should select at least one option';
    },
    verifyPhoneNumbers: function (numbers, companyCountryCode) {
        return new Promise(function (resolve, reject) {
            let cleanPhoneNumbers = [];
            for (let phone of numbers) {
                if (phone.startsWith('+') || phone.startsWith('00')) {
                    phone = phone.replace(/^00/, '');
                    phone = phone.replace('+', '');
                    phone = phone.replace('-', '');
                } else {
                    phone = phone.replace(/^0/, '');
                    phone = phone.replace('-', '');
                    phone = companyCountryCode + phone;
                }
                cleanPhoneNumbers.push(phone);
            }
            let stringifiedNumbers = JSON.stringify(cleanPhoneNumbers);

            window.axios.get(VERIFIY_NUMBERS_BACKEND, {params: {numbers: stringifiedNumbers}})
                .then(response => {
                    resolve(response.data)
                })
                .catch(response => {
                    reject(response)
                })

        });
    }
}